/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  SubscriptionUserControllerPurchaseMutationRequest,
  SubscriptionUserControllerPurchaseMutationResponse,
  SubscriptionUserControllerPurchasePathParams,
  SubscriptionUserControllerPurchase401,
} from '../../types/SubscriptionUserControllerPurchase.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { subscriptionUserPurchase } from '../../methods/subscriptionUserPurchase.ts';
import { useMutation } from '@tanstack/react-query';

export const subscriptionUserPurchaseMutationKey = () =>
  [{ url: '/api/user/telegram/subscriptions/plans/:planId' }] as const;

export type SubscriptionUserPurchaseMutationKey = ReturnType<typeof subscriptionUserPurchaseMutationKey>;

/**
 * {@link /api/user/telegram/subscriptions/plans/:planId}
 */
export function useSubscriptionUserPurchase<TContext>(
  options: {
    mutation?: UseMutationOptions<
      SubscriptionUserControllerPurchaseMutationResponse,
      ResponseErrorConfig<SubscriptionUserControllerPurchase401>,
      {
        planId: SubscriptionUserControllerPurchasePathParams['planId'];
        data?: SubscriptionUserControllerPurchaseMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<SubscriptionUserControllerPurchaseMutationRequest>> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? subscriptionUserPurchaseMutationKey();

  return useMutation<
    SubscriptionUserControllerPurchaseMutationResponse,
    ResponseErrorConfig<SubscriptionUserControllerPurchase401>,
    {
      planId: SubscriptionUserControllerPurchasePathParams['planId'];
      data?: SubscriptionUserControllerPurchaseMutationRequest;
    },
    TContext
  >(
    {
      mutationFn: async ({ planId, data }) => {
        return subscriptionUserPurchase(planId, data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
